export enum DynamicFormSchemaType {
  Input = 'input',
  Select = 'select',
  Explorer = 'explorer',
  Checkbox = 'checkbox',
  List = 'list',
  Dict = 'dict',
  Ipaddr = 'ipaddr',
}
